export default "__VITE_ASSET__CthEbzZH__"